import { AudioPlayerProvider } from 'react-use-audio-player'
import { MotePlayerProvider } from '../contexts/motePlayer.context'

/**
 * @deprecated
 */
export const MotePlayerProviders = props => {
  const {
    children,
    isStandalone = true,
    isLandingPage = false,
    ...rest
  } = props

  return isStandalone ? (
    <AudioPlayerProvider>
      <MotePlayerProvider isLandingPage={isLandingPage} {...rest}>
        {children}
      </MotePlayerProvider>
    </AudioPlayerProvider>
  ) : (
    <>{children}</>
  )
}
